import React, { useEffect, useRef, useState } from 'react';
import { Handshake, Camera, Target, Calendar } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  handshake: Handshake,
  camera: Camera,
  target: Target,
  calendar: Calendar,
};

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="services"
      ref={sectionRef}
      className="relative py-24 md:py-32 bg-[#121212]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-[#D4AF37] text-xs tracking-[0.4em] mb-4">OFFERINGS</p>
          <h2 className="font-playfair text-3xl md:text-4xl text-white">
            How We Can <span className="italic text-[#D4AF37]">Collaborate</span>
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className={`group relative p-8 bg-[#0A0A0A]/50 border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all duration-700 ease-out hover:-translate-y-2 hover:shadow-[0_10px_40px_rgba(212,175,55,0.1)] ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="mb-6">
                  <IconComponent
                    className="text-[#D4AF37] group-hover:scale-110 transition-transform duration-500"
                    size={32}
                    strokeWidth={1.5}
                  />
                </div>

                {/* Title */}
                <h3 className="text-white text-lg mb-3 relative inline-block">
                  {service.title}
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#D4AF37] group-hover:w-full transition-all duration-500" />
                </h3>

                {/* Description */}
                <p className="text-[#A1A1AA] text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Decorative Corner */}
                <div className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#D4AF37]/20 group-hover:border-[#D4AF37]/60 transition-colors duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
